const { onlyNumericPlusDash, SPACE } = require('../helpers');

const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District of Columbia',
  AS: 'American Samoa',
  GU: 'Guam',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  UM: 'United States Minor Outlying Islands',
  VI: 'Virgin Islands'
};

const stateOptions = Object.keys(states).map((stateCode) => ({
  value: stateCode,
  name: states[stateCode]
}));

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumericPlusDash(zipCode);
  if (zipCode.length <= 5) {
    return zip;
  }
  return `${zip.slice(0, 5)}-${zip.slice(6, 10)}`;
};

exports.countryDefinition = {
  country: 'United States',
  code: 'US',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'State',
      width: 0.5
    },
    zipCode: {
      label: 'Zip Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'stateCode', SPACE, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/),
      error: 'Must be 5 characters or 5+4, 12345 or 12345-1234'
    }
  ]
};
